import { Components } from 'formiojs';
import editForm from './Component.form';
import PremiumUtils from '../../utils';
var BaseComponent = Components.components.component;
BaseComponent.prototype.afterComponentAssign = function () {
    var _a, _b, _c, _d, _e;
    if (this.builderMode) {
        PremiumUtils.transformSimpleConditions(this.component, ((_b = (_a = this.root) === null || _a === void 0 ? void 0 : _a._form) === null || _b === void 0 ? void 0 : _b.components) || ((_e = (_d = (_c = this.options) === null || _c === void 0 ? void 0 : _c.root) === null || _d === void 0 ? void 0 : _d._form) === null || _e === void 0 ? void 0 : _e.components));
    }
};
Components.baseEditForm = editForm;
BaseComponent.editForm = editForm;
export default BaseComponent;
